<script setup>
import { storeToRefs } from 'pinia';

import { Bot } from 'lucide-vue-next';

import { useMutationReviewBadgeStore } from '@/stores/mutationReviewBadge';

const badge = useMutationReviewBadgeStore();
const { count } = storeToRefs(badge);
</script>

<template>
  <el-tooltip
    v-if="count > 0"
    :content="$t('AI actions to review in this account')"
    placement="bottom"
  >
    <RouterLink
      class="ai-actions-badge"
      :to="{ name: 'ppc-ai-actions' }"
      :aria-label="$t('AI actions to review')"
    >
      <Bot :size="20" />
      <span v-no-translate class="ai-actions-badge-count">{{ count }}</span>
    </RouterLink>
  </el-tooltip>
</template>

<style lang="scss" scoped>
.ai-actions-badge {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--wp-btn-header);
  color: var(--wp-text-primary);
  text-decoration: none;

  &:hover {
    background: var(--wp-surface-input);
  }

  &:focus-visible {
    outline: 2px solid var(--wp-state-main);
    outline-offset: 2px;
  }
}

.ai-actions-badge-count {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: var(--wp-state-main);
  color: var(--wp-constant-white);
  font-size: 11px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
}
</style>
